import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
    const t = localStorage.getItem("pe_token");
    if (t) cfg.headers.Authorization = `Bearer ${t}`;
    return cfg;
});

export const token = () => localStorage.getItem("pe_token");
